import { render, staticRenderFns } from "./JgpUploader.vue?vue&type=template&id=5e454d14&"
import script from "./JgpUploader.vue?vue&type=script&lang=js&"
export * from "./JgpUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports